module.exports = __webpack_public_path__ + "img/table-layout.ecc16701.svg";